import { Building } from "../../../building/Building";
import { Main } from "../../../Main";
import { InsetBay } from "./InsetBay";
import { InsetBayConfig } from "../../../config/InsetBayConfig";

export class InsetBayManager
{
    private _building : Building;

    private _front : InsetBay[];
    private _back  : InsetBay[];

    private _config: InsetBayConfig;

    constructor(building:Building)
    {
        this._building = building;
        this._config = Main.getInstance().config.building.insetBay;
        this._front = [];
        this._back  = [];

        this._back.push(new InsetBay("back", 0, building));
        this._back.push(new InsetBay("back", 1, building));
        this._front.push(new InsetBay("front", 0, building));
        this._front.push(new InsetBay("front", 1, building));

        this._config.back.count.signal.add(this.backCountChanged);
        //this._config.back.drop.signal.add(this.backDropChanged);
        this._config.back.length_1.signal.add(this.backWidth1Changed);
        this._config.back.length_2.signal.add(this.backWidth2Changed);

        this._config.front.count.signal.add(this.frontCountChanged);
        //this._config.front.drop.signal.add(this.frontDropChanged);
        this._config.front.length_1.signal.add(this.frontWidth1Changed);
        this._config.front.length_2.signal.add(this.frontWidth2Changed);

        Main.getInstance().config.building.gutter.signal.add(this.updateAll);

        //this._config.front.overhang.signal.add(this.updateFrontBays);
        //this._config.back.overhang.signal.add(this.updateBackBays);

        Main.getInstance().config.building.leanto.left.enabled.signal.add(this.updateAll);
        Main.getInstance().config.building.leanto.right.enabled.signal.add(this.updateAll);

        Main.getInstance().config.building.leanto.front.enabled.signal.add(this.updateFrontBays);
        Main.getInstance().config.building.leanto.back.enabled.signal.add(this.updateBackBays);

        Main.getInstance().config.building.leanto.left.drop.signal.add(this.updateAll);
        Main.getInstance().config.building.leanto.right.drop.signal.add(this.updateAll);


        Main.getInstance().config.building.overhang_sides.signal.add(this.updateAll);
        Main.getInstance().config.building.overhang_end.signal.add(this.updateFrontBays);
        Main.getInstance().config.building.overhang_end.signal.add(this.updateBackBays);

        // Main.getInstance().config.building.overhang_left.signal.add(this.updateAll);
        // Main.getInstance().config.building.overhang_right.signal.add(this.updateAll);
        // Main.getInstance().config.building.overhang_front.signal.add(this.updateFrontBays);
        // Main.getInstance().config.building.overhang_back.signal.add(this.updateBackBays);

        Main.getInstance().config.building.single_slope.signal.add(this.updateSingleSlope);

    }
    private backCountChanged = () =>
    {
        this.removeBackInsetBays();
        for (var i = 0; i < this._config.back.count.value; ++i)
        {
            this._back[i].show();
        }
        this.trimWorkaround();
    }
    /*private backDropChanged = () =>
    {
        this._back[0].changeDropTo(this._config.back.drop.value);
        this._back[1].changeDropTo(this._config.back.drop.value);
    }*/

    private backWidth1Changed = () =>
    {
        this._back[0].changeLengthTo(this._config.back.length_1.value);
        this._back[1].update();
    }
    private backWidth2Changed = () =>
    {
        this._back[1].changeLengthTo(this._config.back.length_2.value);
        this._back[0].update();
    }
    private frontCountChanged = () =>
    {
        this.removeFrontInsetBays();
        for (var i = 0; i < this._config.front.count.value; ++i)
        {
            this._front[i].show();
        }
        this.trimWorkaround();
    }
    /*private frontDropChanged = () =>
    {
        this._front[0].changeDropTo(this._config.front.drop.value);
        this._front[1].changeDropTo(this._config.front.drop.value);
    }*/
    private frontWidth1Changed = () =>
    {
        this._front[0].changeLengthTo(this._config.front.length_1.value);
        this._front[1].update();
    }
    private frontWidth2Changed = () =>
    {
        this._front[1].changeLengthTo(this._config.front.length_2.value);
        this._front[0].update();
    }
    private removeBackInsetBays = () =>
    {
        for (var i = 0; i < this._back.length; ++i)
        {
            this._back[i].hide();
        }
    }
    private removeFrontInsetBays = () =>
    {
        for (var i = 0; i < this._front.length; ++i)
        {
            this._front[i].hide();
        }
    }
    private updateFrontBays = () =>
    {
        for (var i = 0; i < this._front.length; ++i)
        {
            this._front[i].update();
        }
    }
    private updateBackBays = () =>
    {
        for (var i = 0; i < this._back.length; ++i)
        {
            this._back[i].update();
        }
    }
    public updateAll = () =>
    {
        this.updateFrontBays();
        this.updateBackBays();
    }


    private trimWorkaround = () =>
    {
        // requestAnimationFrame(() =>
        // {
		// 	var building = Main.getInstance().config.building;
		// 	building.pitch.setValue(building.pitch.value-0.01);

		// 	requestAnimationFrame(() =>
        //     {
		// 		var building = Main.getInstance().config.building;
		// 		building.pitch.setValue(building.pitch.value+0.01);

		// 		requestAnimationFrame(() =>
        //         {
		// 			Main.getInstance().render = true;
        //         });
        //     });
        // });
    };

    private updateSingleSlope = () =>
    {
        this.updateAll();
        this.trimWorkaround();
    }
}

